// ~1,5 Mo en base64
const MAX_PNG_LENGTH: number = 2_000_000;

export const UploadService = {
  handleFileToBase64: (file: File) => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  },

  // Redimensionne une image (plus grand côté <= maxSize).
  // Les formats pouvant être transparents sont ré-encodés en PNG, les autres en JPEG.
  resizeImageToBase64: (file: File, maxSize: number = 1920, quality: number = 0.85) => {
    const transparent: boolean = ['image/png', 'image/gif', 'image/webp', 'image/svg+xml'].includes(file.type);

    return new Promise<string>((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();

      image.onload = () => {
        const ratio = Math.min(1, maxSize / Math.max(image.width, image.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(image.width * ratio);
        canvas.height = Math.round(image.height * ratio);

        const context = canvas.getContext('2d');

        if (context === null) {
          URL.revokeObjectURL(url);
          reject(new Error('Canvas not supported'));
          return;
        }

        if (!transparent) {
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, canvas.width, canvas.height);
        }

        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);

        if (transparent) {
          const png: string = canvas.toDataURL('image/png');

          if (png.length <= MAX_PNG_LENGTH) {
            resolve(png);
            return;
          }

          // PNG trop lourd (photo plutôt que logo) : passage en JPEG sur fond blanc
          context.globalCompositeOperation = 'destination-over';
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, canvas.width, canvas.height);
        }

        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      image.onerror = () => {
        // Fichier illisible comme image : envoyé tel quel, l'API renverra l'erreur de validation
        URL.revokeObjectURL(url);
        UploadService.handleFileToBase64(file).then(resolve, reject);
      };
      image.src = url;
    });
  },
}
